import styled from 'styled-components';
import {
  colorVariables,
  fontFamilyVariables,
  fontVariables,
  mediaTemplates,
} from 'theme/variables';

export const RatingLabelStyled = styled.div`
  font-family: ${fontFamilyVariables.din_regular};
`;

export const Value = styled.div`
  font-size: ${fontVariables.fs_xxl};
  color: #333;
  ${mediaTemplates.l} {
    font-size: ${fontVariables.fs_xxxl};
  }
`;

export const Name = styled.div`
  margin-top: 3px;
  font-size: ${fontVariables.fs_s};
  color: ${colorVariables.gray};
`;
